var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76775 5.58781L11.8841 0.293629C11.9736 0.200569 12.0799 0.126722 12.1971 0.0763313C12.3142 0.0259407 12.4398 0 12.5667 0C12.6935 0 12.8191 0.0259407 12.9363 0.0763313C13.0534 0.126722 13.1598 0.200569 13.2492 0.293629C13.4291 0.482311 13.5299 0.73669 13.5299 1.00173C13.5299 1.26676 13.4291 1.52114 13.2492 1.70982L7.45264 7.70909C7.27673 7.8903 7.04011 7.9944 6.79195 7.99978C6.54379 8.00516 6.30316 7.91139 6.12007 7.73797L0.283962 1.71223C0.102472 1.52491 0.00032789 1.27066 7.88033e-07 1.00541C-0.000326314 0.740159 0.10119 0.485639 0.282218 0.29784C0.463246 0.110041 0.708955 0.00434651 0.965294 0.00400803C1.22163 0.00366956 1.4676 0.108715 1.64909 0.296035L6.76775 5.58781Z",
    fill: "#213345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/Expand-icon.8b41ecb4da42b21e67d5e32f7303a657.svg";
export { ForwardRef as ReactComponent };